import { useContext, useEffect } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import ElectronIPC from '../../services/ElectronIPC'
import ScheduleSessionPage from './ScheduleSessionPage'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

const windowName = 'Dialog:ScheduleSessionDialog'

export default function ScheduleSessionPageController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const { showScheduleSessionDialog } = appState.appState

    const onClose = () => {
        appDispatch({
            type: 'update_app_state',
            value: {
                showScheduleSessionDialog: { isOpen: false },
            },
        })
    }

    useEffect(() => {
        // focus already-open modal.
        if (appState.appState.showScheduleSessionDialog?.isOpen) {
            ElectronIPC.setWindowOptions({ windowName: windowName, triggerFocus: true })
        }
    }, [appState.appState.showScheduleSessionDialog])

    if (!showScheduleSessionDialog?.isOpen) {
        return null
    }

    return (
        <CrossPlatformDialog forceBrowserModal classNameBrowser="md:w-[600px]" onDefaultClose={onClose}>
            <ScheduleSessionPage
                editingSession={showScheduleSessionDialog.editingSession}
                viewSession={showScheduleSessionDialog.viewSession}
                isSingleInSeries={showScheduleSessionDialog.isSingleInSeries}
                onClose={onClose}
            />
        </CrossPlatformDialog>
    )
}
